import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS, ModalState } from '@yme/modals/constants';
import { getExpiredSessionLabels } from '@yme/selectors/common';
export const useShowModalSessionExpired = () => {
    const dispatch = useDispatch();
    const { sessionExpiredMessage, sessionExpiredTitle } = useSelector(getExpiredSessionLabels);
    const showModal = useCallback(({ submitCallback, closeCallback = submitCallback, modalTitle, modalMessage, }) => {
        dispatch(setIsModalShowed({
            type: MODALS.ALERT_MESSAGE_MODAL,
            data: {
                state: ModalState.WARNING,
                title: modalTitle || sessionExpiredTitle,
                content: modalMessage || sessionExpiredMessage,
                primaryButtonContent: 'Ok',
                callback: () => submitCallback?.(),
                handleClose: () => closeCallback?.(),
            },
        }));
    }, [dispatch, sessionExpiredTitle, sessionExpiredMessage]);
    return {
        showModalSessionExpired: showModal,
    };
};
